export const parseUrl = (url) => {
    const regex = /[?&]([^=#]+)=([^&#]*)/g;
    const params = {};
    let match = regex.exec(url);
    while (match) {
        params[match[1]] = match[2];
        match = regex.exec(url);
    }
    return params;
};
